// Import data and Firebase dependencies
import voiceData from '../assets/arranged_voices.json';
import { db } from '../config/firebase'; // Make sure this import exists
import { doc, getDoc } from 'firebase/firestore';

const processVoiceData = (data) => ({
  id: data.id,
  name: data['Display Name'],
  description: data.Description,
  previewUrl: data.preview_link,
  gender: data.Gender,
  type: data.type,
  tags: data.tags || [],
  Age: data.Age,
  isPrivate: data.isPrivate || false
});

const processPrivateVoiceData = (data) => ({
  id: data.id,
  name: data['Display Name'],
  description: "Instant Voice Clone",
  previewUrl: data.preview_link,
  gender: data.Gender,
  type: "Private",
  tags: data.tags || ["Private"],
  Age: data.Age,
  isPrivate: data.isPrivate || true
});

// Get private voices for a user
export const getPrivateVoices = async (userEmail) => {
  if (!userEmail) return [];
  
  try {
    const privateVoicesRef = doc(db, 'private_voices', userEmail);
    const docSnap = await getDoc(privateVoicesRef);
    
    if (docSnap.exists()) {
      const privateVoicesData = docSnap.data().voices || [];
      return privateVoicesData.map(processPrivateVoiceData);
    }
    return [];
  } catch (error) {
    console.error('Error fetching private voices:', error);
    return [];
  }
};

// Get all voices (private + arranged)
export const getAllVoices = async (userEmail) => {
  const privateVoices = await getPrivateVoices(userEmail);
  const arrangedVoices = voiceData.map(processVoiceData);
  
  return [...privateVoices, ...arrangedVoices];
};

// Export the raw VOICES data for backward compatibility
export const VOICES = voiceData.map(processVoiceData);

// Keep helper functions
export const updateVoiceTokens = (voices, newToken) => {
  return voices.map(voice => ({
    ...voice,
    previewUrl: voice.previewUrl.split('?')[0] + '?' + newToken
  }));
};

export const addVoice = (voicesArray, newVoice) => {
  return [...voicesArray, newVoice];
};

export const removeVoice = (voicesArray, voiceId) => {
  return voicesArray.filter(voice => voice.id !== voiceId);
};

export const updateVoice = (voicesArray, voiceId, updates) => {
  return voicesArray.map(voice =>
    voice.id === voiceId ? { ...voice, ...updates } : voice
  );
};